"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("../one");
const cell_1 = __importDefault(require("../cell"));
const form_value_1 = __importDefault(require("../form-value"));
const Picker = (props) => {
    const { label, border, required, icon, pickerAlign = 'left', options, value, onChange, placeholder, children, disabled, } = props;
    const handleChangePicker = (e) => {
        if (e.detail.value < 0) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(options === null || options === void 0 ? void 0 : options[e.detail.value]);
    };
    const valueIndex = (options === null || options === void 0 ? void 0 : options.findIndex((item) => item['key'] === value)) || 0;
    const selectedOption = options === null || options === void 0 ? void 0 : options.find(option => option.key === value);
    return (React.createElement(cell_1.default, { label: label, labelStyle: { width: '180px' }, border: border, required: required, icon: icon, field: true },
        React.createElement(one_1.Picker, { "wechat-mode": "selector", range: options, rangeKey: "value", disabled: disabled, value: valueIndex, onChange: handleChangePicker }, children !== null && children !== void 0 ? children : (React.createElement(form_value_1.default, { placeholder: placeholder, style: {
                textAlign: pickerAlign,
            } }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)))));
};
exports.default = Picker;
